import { render, staticRenderFns } from "./MonthlySSBSubmissionRecordGrid.vue?vue&type=template&id=2973d546"
import script from "./MonthlySSBSubmissionRecordGrid.vue?vue&type=script&lang=js"
export * from "./MonthlySSBSubmissionRecordGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports